class HourCodesController implements ng.IComponentController {
    
    constructor() {
        'ngInject';
    }
    
    public $onInit = () => {
        console.log('HourCodesController initialized');
    }
}

export const hourCodesComponent: ng.IComponentOptions = {
    controller: HourCodesController,
    template: require('./hourCodes.html')
}




// WEBPACK FOOTER //
// ./src/app/modules/settings/hourCodes/hourCodes.component.ts